import * as React from "react"

function BowSvg(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      enableBackground="new 0 0 512 512"
      {...props}
    >
      <path id="XMLID_304_" d="m192.59 137.835c-6.737 0-14.101 2.42-19.184 8.155-6.657 7.51-8.744 29.953-8.497 41.279 11.24.272 32.73-.026 41.436-8.683 9.103-9.053 11.594-24.872 1.914-34.499-4.213-4.19-9.838-6.252-15.669-6.252z"/><path id="XMLID_861_" d="m106.795 137.835c6.737 0 14.101 2.42 19.184 8.155 6.657 7.51 8.744 29.953 8.497 41.279-11.24.272-32.731-.026-41.436-8.683-9.103-9.053-11.594-24.872-1.914-34.499 4.213-4.19 9.838-6.252 15.669-6.252z"/><path id="XMLID_366_" d="m229.471 122.834c17.093 16.996 19.37 43.784 7.659 64.435h230.87v-75.412c0-23.669-19.223-42.857-42.935-42.857h-260.366v46.273c21.042-11.873 47.63-9.484 64.772 7.561 9.738 9.683-17.142-17.045 0 0z"/><path id="XMLID_370_" d="m101.719 271.619-21.301-21.163 33.093-33.187h-113.511v138.873c0 23.67 19.223 42.858 42.935 42.858h91.709v-160.399z"/><path id="XMLID_371_" d="m185.7 217.269 32.652 32.913-21.356 21.108-32.297-32.555v160.265h260.366c23.712 0 42.935-19.188 42.935-42.857v-138.874z"/><path id="XMLID_425_" d="m62.213 187.269c-11.713-20.654-9.432-47.44 7.659-64.435 17.141-17.045 43.729-19.433 64.772-7.561v-46.273h-91.709c-23.712 0-42.935 19.188-42.935 42.857v75.412z"/>    </svg>
  )
}

export default BowSvg
